import { connect } from 'react-redux';

import adminPaymentGateways from '_store/_actions/adminPaymentGateways';

import PaymentMethodGateway from './PaymentMethodGateway';

const mapStateToProps = state => {
  const {
    isLoadingPaymentMethodGateways,
    paymentMethodGateways,
    paymentMethods,
    paymentGateways,
  } = state.adminPaymentGateways;

  return {
    paymentMethodGateways,
    paymentMethods,
    paymentGateways,
    isLoading: isLoadingPaymentMethodGateways,
  };
};

const mapDispatchToProps = {
  onFetchPaymentMethodGateway: adminPaymentGateways.fetchAdminPaymentMethodGateway,
  onCreatePaymentMethodGateway: adminPaymentGateways.createAdminPaymentMethodGateway,
  onUpdatePaymentMethodGateway: adminPaymentGateways.updateAdminPaymentMethodGateway,
  onDeletePaymentMethodGateway: adminPaymentGateways.deleteAdminPaymentMethodGateway,
  onFetchPaymentMethods: adminPaymentGateways.fetchAdminPaymentMethods,
  onFetchPaymentGateways: adminPaymentGateways.fetchAdminPaymentGateways,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethodGateway);
